import axios from "axios";
import {Link, useNavigate} from "react-router-dom";
import React, {useEffect} from "react";
import {DataGrid, GridColDef, GridToolbarContainer, GridToolbarQuickFilter} from "@mui/x-data-grid";
import {Button} from "@mui/material";
import PostAddIcon from "@mui/icons-material/PostAdd";
import Typography from "@mui/material/Typography";
import {NPC} from "../../../server/Plot";


const npcColumns: GridColDef[] = [
    {
        field: 'name', headerName: 'NPC', headerAlign: "center", renderCell: (params) => (
            <Link to={'/npc/' + params.row.id}>{params.value}</Link>
        ), minWidth: 300
    }
]

export async function loadNPCList() {
    const apiEndpoint = "/plot/npcs/named"
    return await axios.get(apiEndpoint).then(({data}) => {
        return data as NPC[];
    })
}

export function NPCList() {
    const [npcs, setNPCs] = React.useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        axios.get("/plot/npcs/named").then(response => {
            setNPCs(response.data)
        })
    }, [])

    function QuickFilterToolBar() {
        return (
            <GridToolbarContainer>
                <GridToolbarQuickFilter/>
                <Button onClick={() => navigate('/npc/new')}><PostAddIcon/></Button>
            </GridToolbarContainer>
        )
    }

    return <React.Fragment>
        <Typography variant="h4" component="h4" align="center">NPCs</Typography>

        <DataGrid slots={{toolbar: QuickFilterToolBar}}
                  autoHeight={true}
                  rows={npcs}
                  columns={npcColumns}
                  getRowId={(row) => row.id}
                  density={"compact"}
                  initialState={{
                      pagination: {
                          paginationModel: {
                              pageSize: 24,
                          },
                      },
                  }}
        />
    </React.Fragment>
}
